module.exports = __webpack_public_path__ + "assets/IsoscelesTriangleAboutCircle.6fc4a1a32a95cdcfa9c8b95a8c1cc095.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/IsoscelesTriangleAboutCircle.gmt
// module id = 960
// module chunks = 0